import * as react_components from "../reactcomponent.js"
import { Button } from "../../core/components/button.js";
import { Innosoft_InnoBI_Controllers_StatisticUiController as Statistics, Innosoft_InnoBI_Controllers_StatisticUi as StatisticUi } from "../generated_api/generated_api.js"
import { RightFloatingButtonScalor } from "../editor_common_components.js";
import React from "react";
export class StatisticPickerControl extends React.Component<{ onTextChange: any, contextVariables: any, value: string, label: string }, { showStatisticsDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showStatisticsDialog: false };
    }

    handleShowServiceSelector = () => {
        this.setState({ showStatisticsDialog: true });
    }

    handleClose = () => {
        this.setState({ showStatisticsDialog: false });
    }

    handleSave = (statisticId) => {
        this.props.onTextChange(statisticId);
        this.setState({ showStatisticsDialog: false });
    }

    extractServiceId = (url: string) => {
        if (url) {
            const end = url.lastIndexOf('/');
            let index = url.substring(end - 37, end);
            return index;
        }
        return url;
    }
    render() {
        var d;
        if (this.state.showStatisticsDialog === true) {
            d = <StatisticPickerDialog onClose={this.handleClose} onSave={this.handleSave} />
        }

        var link = this.props.value ? <a target="_blank" href={this.props.contextVariables.INNO_BASE_PATH + `Statistic/uiBuilderDetail?id=${this.props.value}`}> {this.props.value}</ a> : null;
        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {link}
                    </div>
                </div>
            </li>
        );
    }
};


class StatisticPickerDialog extends React.Component<{ onClose: any, onSave: any }, { statistics: StatisticUi[] }>{
    constructor(props) {
        super(props);
        this.state = { statistics: null };
        new Statistics().GetAllStatisticsUngrouped((result: StatisticUi[]) => {
            this.setState({ statistics: result });
        });
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = (selectedItem: StatisticUi) => {
        this.props.onSave(selectedItem.Id);
    }

    render() {
        var columns = [{
            field: "Name", title: "Statistic", filterable: {
                cell: {
                    operator: "contains",
                    template: function (args) {
                        args.element.css("width", "90%").addClass("k-textbox").keydown(function (e) {
                            setTimeout(function () {
                                $(e.target).trigger("change");
                            });
                        });
                    },
                    showOperators: false
                }
            }
        }];

        return (
            <react_components.BasicDialog title="Select statistic" onClose={this.handleClose}>
                <react_components.KendoGrid filtermode="row" data={this.state.statistics} columns={columns} OnSelectedItemChanged={this.handleSave} />
            </react_components.BasicDialog>
        );
    }
};